import { json_headers, request } from './common';
import type { RequestOptions, SearchServiceEnvelope } from './common';

export type BoostKind = 'lpp_boost' | 'lpc_discount' | 'new_lpc';

export type BoostedCatalogEntry = {
  kind: BoostKind;
  offerId: string;
  name: string;
  place: string;
  value: number;
  startDate: string | null;
  endDate: string | null;
  impressions7d: number;
  lifetimeImpressions: number;
  sales7d: number;
};

export type BoostedCatalog = {
  generatedAt: string;
  entries: Array<BoostedCatalogEntry>;
};

function searchAdminBoostedCatalogPath(): string {
  return `${window.configs.API_HOST}/api/search/admin/v1/boosted-catalog`;
}

export async function getBoostedCatalog(options: RequestOptions = {}): Promise<BoostedCatalog> {
  const response = (await request(searchAdminBoostedCatalogPath(), {
    method: 'GET',
    headers: json_headers,
    signal: options.signal,
  })) as SearchServiceEnvelope<BoostedCatalog>;

  return response.result;
}
